import * as Campaigns     from '../../campaigns';
import * as UI            from '../../ui';
import { isRecordValid }  from '../compose_page';
import { usePageContext } from '../../components/render_page';
import ConfirmModal       from '../../components/confirm_modal';
import Link               from '../../components/link';
import MessagePreview     from './message_preview';
import React              from 'react';
import Recipients         from './recipients';
import useBoolean         from '../../hooks/use_boolean';


export default function DraftStatusPage({ campaign }) {
  return (
    <>
      <Description {...{ campaign }}/>
      <Recipients {...{ campaign }}/>
      <MessagePreview {...{ campaign }}/>
    </>
  );
}


function Description({ campaign }) {
  const { businessID } = usePageContext();
  const editUrl        = `/${businessID}/campaigns/edit/${campaign.id}`;
  const isValid        = isRecordValid(campaign);

  return (
    <div className="block description">
      <h2>This campaign is a draft.</h2>
      {isValid && <ValidDescription {...{ campaign, editUrl }}/>}
      {!isValid && <InvalidDescription {...{ campaign, editUrl }}/>}
    </div>
  );
}


function ValidDescription({ campaign, editUrl }) {
  const { businessID }   = usePageContext();
  const scheduleCampaign = Campaigns.useScheduleCampaign(businessID);
  const toast            = UI.useToast();

  const [ confirmIsOpen, showConfirm, hideConfirm ] = useBoolean();

  async function onClickConfirm() {
    hideConfirm();
    await scheduleCampaign(campaign);
    toast('Campaign scheduled!');
  }

  const numberOfPeople   = campaign.recipients.length;
  const personOrPeople   = (numberOfPeople === 1) ? 'person' : 'people';
  const oneMinute        = 1000 * 60;
  const minutes          = Campaigns.scheduledCampaignDelay / oneMinute;
  const modalDescription = <>Your email will be sent to {numberOfPeople}&nbsp;{personOrPeople}. You’ll have {minutes}&nbsp;minutes to change your&nbsp;mind.</>;

  return (
    <>
      <p>You can <Link href={editUrl}>edit this campaign</Link>, or <Link onClick={showConfirm}>schedule it to be sent.</Link></p>
      <ConfirmModal
        isOpen={confirmIsOpen}
        closeModal={hideConfirm}
        onConfirm={onClickConfirm}
        title="Send Campaign"
        description={modalDescription}
        buttonLabel="Send Campaign"
        buttonClassName="danger"
      />
    </>
  );
}


function InvalidDescription({ editUrl }) {
  return (
    <>
      <p>You can <Link href={editUrl}>edit this campaign</Link>.</p>
    </>
  );
}
